import { useState, useEffect } from "react";
import { ErrorCard, LoadingCard, MainContainer } from "../../components";
import { Button, Input, Card, CardBody } from "@heroui/react";
import { usePost, useFetchWithBody } from "../../api/reactQueryCustomHooks";
import { apiRoute, linksUrl } from "../../constants/enum";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resetDetail, setDetailParams } from "../../state/sizeSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";


const CreateSizeMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { detailParams, isNewEntry } = useSelector((state) => state.size);
  const [submitBtnId, setSubmitBtnId] = useState("")

  const [formData, setFormData] = useState({
    Sz_Code: "",
    Sz_Name: "",
    Sz_Grp: "",
    Sz_Ord: "",
  });

  const { data: sizeDetails = [], isPending: isLoading, mutate: filterDetail } = usePost({
    url: apiRoute.size.GetPSizeForUpdate,
    queryKey: "fetchSizeById",
  });


  // Fetch data when `detailParams?.Sz_Code` exists
  useEffect(() => {
    if (detailParams && Object.keys(detailParams).length > 0) {

      filterDetail({
        data: {
          Sz_Code: detailParams.Sz_Code
        }
      })
    }
  }, [detailParams]);

  useEffect(() => {
    if (!isNewEntry && sizeDetails && Object.keys(sizeDetails).length > 0) {
      setFormData({
        Sz_Code: sizeDetails.Sz_Code || "",
        Sz_Name: sizeDetails.Sz_Name || "",
        Sz_Grp: sizeDetails.Sz_Grp || "",
        Sz_Ord: sizeDetails.Sz_Ord || "",
      });
      console.log(sizeDetails.Sz_Code, isNewEntry, formData)

    }
  }, [sizeDetails]);



  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const { mutate: AddUpdatePSize, isPending, isError } = usePost({
    queryKey: "size",
    url: apiRoute.size.AddUpdatePSize,
    successMessage: "Size saved successfully!",
    onSuccessTasks: () => {
      dispatch(resetDetail());
      if (submitBtnId == 'btnSaveNew') {
        setFormData({
          Sz_Code: "",
          Sz_Name: "",
          Sz_Grp: "",
          Sz_Ord: "",
        })
      }
      else
        navigate(linksUrl.diamondParamater.size.sizeMaster);
    },
  });

  const onSuccessChkDupCode = (data) => {
    let isDuplicate = 0
    if (isNewEntry && data && data.length > 0) {
      
      if (data[0].count > 0) {
        if (!toast.isActive("toast_chkszid")) {
          toast.error(`Duplicate Size Code Not Allow It Must Be Unique `, {
            "position": "top-center",
            "className": "toast-error",
            toastId: "toast_chkszid"
          })
          setFormData({...formData,Sz_Code:""})
        }
        isDuplicate = 1
        
      }
    }
    if (isDuplicate == 0) {
      AddUpdatePSize({
        data: {
          ...formData,
          UID: user.username,
          pRecStatus: 2,
        }
      });

    }
  }
  const { mutate: funCheckDuplicateSzCode } = usePost({
    queryKey: "CheckSzCode",
    url: apiRoute.size.CheckSzCode,
    onSuccessTasks: onSuccessChkDupCode
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitBtnId(e.nativeEvent.submitter.id)
    if (!formData.Sz_Code.trim() || !formData.Sz_Name.trim()) {
      toast.warn("Sz_Code and Sz_Name are required.");
      return;
    }

    if (isNewEntry) {
      funCheckDuplicateSzCode({
        data: {
          SZ_CODE: formData.Sz_Code
        }
      })
    }
    if (!isNewEntry) {
      AddUpdatePSize({
        data: {
          ...formData,
          UID: user.username,
          pRecStatus: 1,
        }
      });
    }

  };

  const { data: ordData = [] } = useFetchWithBody({
    url: apiRoute.size.getNextSzOrd,
    queryKey: "getNextSzOrd",
  });


  useEffect(() => {
    if (isNewEntry) {
      setFormData((prev) => ({
        ...prev,
        Sz_Ord: ordData.nextSzOrd,
      }));
    }
  }, [isNewEntry, ordData]);
  if (isLoading || isPending) return <LoadingCard />;
  if (isError) return <ErrorCard />;


  return (
    <MainContainer
      pageName="Size Entry"
      breadcrumbs={["Diamond Parameter", "Size Master"]}
      prevPage={{ show: true, onClick: () => navigate(linksUrl.diamondParamater.size.sizeMaster) }}
    >
      <Card className="p-6">
        <CardBody>

          <form onSubmit={handleSubmit}>
            <div className="grid gap-4">
              <Input label="Size Code" size="sm" maxLength={10}
                readOnly={isNewEntry ? false : true} name="Sz_Code" value={formData.Sz_Code} onChange={handleChange} isRequired />
              <h2 className="text-red-300 " style={{ fontSize: "0.7rem" }}>Size code cannot be longer than 10 characters</h2>
              <Input label="Size Name" size="sm" name="Sz_Name" value={formData.Sz_Name} onChange={handleChange} isRequired />
              <Input label="Size Group" size="sm" name="Sz_Grp" value={formData.Sz_Grp} onChange={handleChange} />
              <Input label="Size Order" size="sm" name="Sz_Ord" type="number" value={formData.Sz_Ord} onChange={handleChange} />
              <div className="flex  gap-4 justify-center" >
                <Button type="submit" size="sm" id="btnSave" color="primary" isLoading={isPending}>
                  {isNewEntry ? "Save" : "Update"}
                </Button>
                <Button
                  id="btnSaveNew"
                  color="success"
                  type="submit"
                  size="sm"
                  variant="shadow"
                  className="text-white"
                  startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                >
                  Save & New
                </Button>
              </div>

            </div>
          </form>

        </CardBody>
      </Card>
    </MainContainer>
  );
};

export default CreateSizeMaster;

